module.exports = __webpack_public_path__ + "static/omeroid-techblog-fff8e85b399a40c4bec636f286ae6003.png";